module.exports = __webpack_public_path__ + "media/subway/D-014c0780.png";